import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/Application/Hooks/Redux';
import type { ISinglePayment } from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';
import { PaymentProcessor } from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';
import { setSelectedPaymentMethods } from '@/modules/perseo-billing/store/slices/billing';

const getPaymentMethodToAdd = (
  token: string,
  installments: number,
  saveCard?: boolean,
  methodId?: PaymentProcessor
): ISinglePayment => ({
  paymentProcessor: methodId ?? PaymentProcessor.TRANSBANK,
  paymentToken: token,
  installments: installments ?? 1,
  isNewCard: true,
  saveCard: saveCard ?? false
});

const useHandlePaymentMethod = ({
  methodId
}: {
  methodId: PaymentProcessor;
}) => {
  const { data: cart } = useAppSelector((state) => state.cart);
  const dispatch = useDispatch();
  const form = useFormContext<IFormFields>();

  if (!cart) return;

  const handlePayment = async (
    token: string,
    _pmData: spreedly.SpreedlyPaymentMethod,
    installments: number
  ) => {
    const tokenField = document.getElementById(
      'payment_method_token'
    ) as HTMLInputElement;

    tokenField.setAttribute('value', token);

    const isSaveCard = form.watch('saveCard');

    const paymentMethodToAdd = getPaymentMethodToAdd(
      token,
      installments,
      isSaveCard,
      methodId
    );

    dispatch(
      setSelectedPaymentMethods({
        payments: [paymentMethodToAdd]
      })
    );
  };

  return { handlePayment };
};

export default useHandlePaymentMethod;
